import React from "react";
import '../style/team.css'
import '../App.css';

const Team = () => {
    return (
        <>
            <body className="ourTeam">
            <h1 id="leadership-title" className="committee">Leadership</h1>
            <div className="second">
                <div className="coordinator">
                    <img src={"/team/Aethyr.jpg"} alt={"Aethyr Villela"} loading={"lazy"}/>
                    <div>
                        <h1 id="leadership-name">Aethyr "Yam" Villela</h1>
                        {/*<h2>Mechanical Engineering | Senior</h2>*/}
                        <h3>Co-Director</h3>
                        <p className="team-bio">
                            Hi! I’m Aethyr, pronounced e-ther, and I’m a senior BME. I have competed at MDM for the past 2 years, loved it, 
                            and am happy to serve as one of your Directors this year! I am passionate about designing and commercializing 
                            medical devices and also working with startups. I will be serving as the VPE of BMES for a second year. Outside of BME,
                             I do research in the ME department, am an officer for UT’s Engineering Chamber Orchestra, and in Fall 2025 am interning
                              at CTAN. I love listening to music, drinking coffee, and bananas! 
                        </p>
                    </div>
                </div>
                <div className="coordinator">
                    <img src={'/team/amrita-arora.jpg'} alt={"Amrita Arora"} loading={"lazy"}/>
                    <div>
                        <h1 id="leadership-name">Amrita Arora</h1>
                        {/*<h2>Biomedical Engineering | Senior</h2>*/}
                        <h3>Co-Director</h3>
                        <p> 
                            I seek to innovate against health disparity by gaining experience in medical device design/product development 
                            and undergraduate research in the drug delivery applications of polyelectrolyte complex micelles. I've been 
                            inspired to focus on equitable medical device design and health disparities through work on an NSF Broadening 
                            Participation seed grant project, B-SEED. I'm currently co-directing the 2026 National Medical Device Make-a-thon, 
                            a healthcare hackathon designed to provide students with an opportunity to go through the full iterative design 
                            process for a medical device and get real-time feedback and mentoring from professionals.
                        </p>
                    </div>
                </div>
            </div>
            <h1 className="committee">Our Team</h1>
            <div className="team">
                <div className="team-member">
                    <img src={"/team/Aithreya-Thoppay-Egambara.jpg"} alt={"Aithreya Thoppay"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Judge/Mentor Head</h3>
                        <div className="person">
                            {/* <img src={require("../images/OU_Logo.png")} alt={"OU"} loading={"lazy"}/> */}
                            <div>
                                <h3 className="name">Aithreya Thoppay</h3>
                                <span className="academics">Biomedical Engineering | Sophomore</span>
                            </div>
                        </div>
                        <p>
                            Hello! I’m Aithreya, a sophomore studying Biomedical Engineering at UT Austin. I’m passionate 
                            about medical device innovation, surgical robotics, and biomaterials. I work on a clinical trial 
                            team at Dell Seton Medical Center evaluating an EMS device for ICU-acquired weakness, and through 
                            the Health Leadership Apprentice Program I research AI policy implications in healthcare. 
                            I also serve as a student associate consultant for healthtech startups through Texas Health Catalyst. 
                            Outside of academics, I love playing violin, painting, exploring cafés, caring for my pet birds, 
                            drinking matcha, and watching 2000s shows. Long-term, I hope to become a physician-engineer who 
                            designs impactful devices and integrates innovation into compassionate, patient-centered care.
                        </p>
                    </div>
                </div>
                <div className="team-member">
                    <img src={"/team/PolinaLee.png"} alt={"Polina Lee"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Judge/Mentor Head</h3>
                        <div className="person">
                            {/* <img src={require("../images/OU_Logo.png")} alt={"OU"} loading={"lazy"}/> */}
                            <div>
                                <h3 className="name">Polina Lee</h3>
                                <span className="academics">Biomedical Engineering | Junior</span>
                            </div>
                        </div>
                        <p>
                            Polina is sophomore Biomedical Engineering undergraduate at University of Texas at Austin. She is interested 
                            in health maintenance devices, AI implementation within healthcare, and healthcare policy. 
                            She has experience in genomics research, general programming, and engineering prototyping.
                        </p>
                    </div>
                </div>
                <div className="team-member">
                    <img src={"/team/Rebecca-Wylie.jpg"} alt={"Rebecca Wylie"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Treasurer</h3>
                        <div className="person">
                            {/* <img src={require("../images/OU_Logo.png")} alt={"OU"} loading={"lazy"}/> */}
                            <div>
                                <h3 className="name">Rebecca Wylie</h3>
                                <span className="academics">Biomedical Engineering | Sophomore</span>
                            </div>
                        </div>
                        <p>
                            I am interested in leveraging computational tools and artificial intelligence to arrive at more 
                            effective healthcare solutions. To this end, I am currently pursuing computational biomedical 
                            engineering— researching ML for image analysis in the Dynamic Medical Imaging and Computing lab, 
                            building a low-cost infrared vein finder, and developing Python-based programs that store biomedical 
                            data. I work on two student-led projects as part of Texas Engineering World Health, and I have 
                            competed in two biomedical design and case competitions this school year.
                        </p>
                    </div>
                </div>
                <div className="team-member">
                    <img src={"/team/Joel-Gonzalez.jpg"} alt={"Joel Gonzalez"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">BMES VP Finance</h3>
                        <div className="person">
                            {/* <img src={require("../images/OU_Logo.png")} alt={"OU"} loading={"lazy"}/> */}
                            <div>
                                <h3 className="name">Joel Gonzalez</h3>
                                <span className="academics">Biomedical Engineering | Senior</span>
                            </div>
                        </div>
                        <p> 
                            Joel Gonzalez is a Biomedical Engineering student at The University of Texas at Austin. 
                            His interests include 
                            rehabilitation therapy and medical devices along with lumbar spine and neurological research. 
                            They are also a part of the Texas Biomedical Engineering Society in which they are the Vice 
                            President of Finance. This role includes creating budget sheets for $15,000+, instructing 
                            other officers in ways to improve their budgeting and financial expertise, organize 
                            fundraising across campus and coordinating with 150+ members to attend these fundraising events.
                        </p>
                    </div>
                </div>                
                <div className="team-member">
                    <img src={"/team/Anany-Anand.png"} alt={"Ananya Anand"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Sponsorship Head</h3>
                        <div className="person">
                            {/* <img src={require("../images/OU_Logo.png")} alt={"OU"} loading={"lazy"}/> */}
                            <div>
                                <h3 className="name">Ananya Anand</h3>
                                <span className="academics">Biomedical Engineering | Sophomore</span>
                            </div>
                        </div>
                        <p>
                            Ananya researches regenerative medicine 
                            and neural engineering in the Seidlits Lab and the Laboratory of Biomaterials, Drug Delivery, 
                            and Bionanotechnology at UT. She focuses on mitigating secondary spinal cord injury by 
                            conditioning neural stem cell microenvironments with IPN hydrogels and studying nanoparticles 
                            synthesized using inverse emulsion polymerization. Ananya hopes to advance treatments for 
                            pediatric neurological and genetic disorders in the future. In her free time, she enjoys singing, 
                            night drives, visiting coffee shops, and spending time at the beach/pool!
                        </p>
                    </div>
                </div>
                <div className="team-member">
                    <img src={"/team/meha-karthik.jpg"} alt={"Meha Swati Karthik"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Sponsorship</h3>
                        <div className="person">
                            {/* <img src={require("../images/OU_Logo.png")} alt={"OU"} loading={"lazy"}/> */}
                            <div>
                                <h3 className="name">Meha Swati Karthik</h3>
                                <span className="academics">Biomedical Engineering | Sophomore</span>
                            </div>
                        </div>
                        <p>
                            Meha is a Sophomore with interests in medical device innovation and biotechnology. She is also pursuing a 
                            minor in Entrepreneurship to develop medical devices. Passionate about bridging engineering and medicine 
                            to create accessible healthcare solutions, Meha works in the Baker Lab, serves as an Associate Consultant 
                            for the Health Catalyst Program, and is a Student Liaison for University Health Services as a part of the 
                            Student Health Advisory Committee. Outside of school she enjoys coaching kids archery, discovering new 
                            music and hiking around Austin.
                        </p>
                    </div>
                </div>
                <div className="team-member">
                    <img src={"/team/zeynep-yakay.jpg"} alt={"Zeynep Yakay"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Sponsorship</h3>
                        <div className="person">
                            {/* <img src={require("../images/OU_Logo.png")} alt={"OU"} loading={"lazy"}/> */}
                            <div>
                                <h3 className="name">Zeynep N. Yakay</h3>
                                <span className="academics">Biomedical Engineering | Senior</span>
                            </div>
                        </div>
                        <p>
                            I’m Zeynep N. Yakay, a fourth-year Biomedical Engineering student at UT Austin. I work on the 
                            Computational Team for the Baby Connect project, where I focus on the device side of our 
                            research. My work bridges embedded systems and data processing to ensure our team can reliably 
                            acquire and analyze wearable-based interaction data. Outside the lab, I enjoy spending time 
                            outdoors, exploring parks and hiking, as well as creative hobbies like piano and photography.
                        </p>
                    </div>
                </div>
                                <div className="team-member">
                    <img src={"/team/mia-chapin.jpg"} alt={"Mia Chapin"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Website Head</h3>
                        <div className="person">
                            {/* <img src={require("../images/OU_Logo.png")} alt={"OU"} loading={"lazy"}/> */}
                            <div>
                                <h3 className="name">Mia Chapin</h3>
                                <span className="academics">Biomedical Engineering | Junior</span>
                            </div>
                        </div>
                        <p>
                            Mia Chapin is a undergraduate at UT Austin studying biomedical engineering with a minor in computer 
                            science. She’s passionate about women’s health and is a research lead in the Women’s Relief 
                            Initiative, which aims to reduce period poverty by designing biodegradable menstrual pads. After 
                            college she hopes to go into industry and combine her interests of computer and electrical engineering 
                            with biomedical engineering in order to design accessible medical devices. Outside of school she 
                            enjoys knitting, rock climbing, and playing the cello.
                        </p>
                    </div>
                </div>
                <div className="team-member">
                    <img src={"/team/Nandini-Senthilkumar.jpg"} alt={"Nandini Senthilkumar"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Social Media</h3>
                        <div className="person">
                            {/* <img src={require("../images/OU_Logo.png")} alt={"OU"} loading={"lazy"}/> */}
                            <div>
                                <h3 className="name">Nandini Senthilkumar</h3>
                                <span className="academics">Biomedical Engineering | Sophomore</span>
                            </div>
                        </div>
                        <p>
                            Nandini is a biomedical engineering student with a strong passion for applying biomechanics, regenerative 
                            medicine, and biotechnology to address chronic illnesses. She conducts research in the Soft Tissue 
                            Biomechanics Lab at UT Austin, where she studies the fatigue mechanics of blood clots. Outside of research, 
                            Nandini contributes to the Longhorn Neurotech Prosthetic/Hardware team, serves as an executive officer of 
                            the Biomedical Engineering Society, and performs with the Longhorn Marching Band. Looking ahead, she hopes 
                            to pursue research in biomaterials for clinical applications. In her free time, she enjoys crocheting, 
                            drawing, making music, and rock climbing!
                        </p>
                    </div>
                </div>
                <div className="team-member">
                    <img src={"/team/Shae-Aguillardo.png"} alt={"Shae Aguillardo"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Liason</h3>
                        <div className="person">
                            {/* below is if you want to add a school logo */}
                            {/* <img src={require("../images/I_logo.png")} alt={"UIUC"} loading={"lazy"}/> */}
                            <div>
                                <h3 className="name">Shae Nicole Aguillardo</h3>
                                <span className="academics">Biomedical Engineering | Junior</span>
                            </div>
                        </div>
                        <p>
                            Shae blends her passion for women’s health with biomechanics research in Dr. Silvia Blemker’s M3 Lab, where 
                            she computationally models pelvic floor and lower body muscle dynamics. She’s drawn to creative problem-solving 
                            through medical device design, especially in surgical and underserved health contexts. In her free time, you’ll 
                            find her playing viola or guitar, bird watching, and mentoring fellow undergrads. Long term, she hopes to 
                            become a physician-scientist engineering solutions that address unmet clinical needs in underrepresented communities.
                        </p>
                    </div>
                </div>
                <div className="team-member">
                    <img src={"/team/Nicole-Randazzo.jpg"} alt={"Nicole Randazzo"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Liason</h3>
                        <div className="person">
                            {/* <img src={require("../images/I_logo.png")} alt={"UIUC"} loading={"lazy"}/> */}
                            <div>
                                <h3 className="name">Nicole Randazzo</h3>
                                <span className="academics">Biomedical Engineering | Junior</span>
                            </div>
                        </div>
                        <p>
                            Nicole is an incoming Junior with a major in Biomedical Engineering. She is interested in medical fields related to 
                            coding, medical devices, robotics, and prosthetics. On campus, she is a member of the Biomendical Engineering 
                            Society and UT’ Brazilian Jiu-Jitsu Group. Outside of college, she is a member of Montessori Model United Nations. 
                            In her free time, she loves swimming, jiu-jitsu, reading, painting, drawing, crocheting, sewing, and sleeping. 
                        </p>
                    </div>
                </div>
                <div className="team-member">
                    <img src={"/team/laasya-karnati.png"} alt={"Laasya Karnati"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Merchandise Coordinator</h3>
                        <div className="person">
                            <div>
                                <h3 className="name">Laasya Karnati</h3>
                                <span className="academics">Biomedical Engineering | Junior</span>
                            </div>
                        </div>
                        <p>
                            Laasya is a third-year undergraduate student majoring in biomedical engineering, with a minor 
                            in humanitarian engineering. She has a strong passion for neonatal medicine, medical imaging, 
                            and biomechanics. In the Parekh Lab, her research focuses on using 3D breast cancer spheroids 
                            to investigate metabolic reprogramming and chemoresistance. At UT, Laasya is a member of a 
                            dance team, Finance Chair for Phi Delta Epsilon, and Vice President of Enrollment for the Council 
                            for Global Health Scholars. In her free time, she enjoys trying new foods, shopping, and spending 
                            time with friends.
                        </p>
                    </div>
                </div>
                {/* <div className="team-member">
                    <img src={"/team/Matson.jpg"} alt={"Cayman Matson"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Logistics Coordinator</h3>
                        <div className="person">
                            <div>
                                <h3 className="name">Cayman Matson</h3>
                                <span className="academics">Biomedical Engineering | Senior</span>
                            </div>
                        </div>
                        <p>
                            fill
                        </p>
                    </div>
                </div> */}
                {/* <div className="team-member">
                    <img src={"/team/Fisher.png"} alt={"Mecca Fisher"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Judge & Mentor Coordinator</h3>
                        <div className="person">
                            <div>
                                <h3 className="name">Mecca Fisher</h3>
                                <span className="academics">Biomedical Engineering | Junior</span>
                            </div>
                        </div>
                        <p>
                            fill
                        </p>
                    </div>
                </div> */}
                {/* <div className="team-member">
                    <img src={"/team/Cunningham.png"} alt={"Joshua Cunningham"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Judge & Mentor Coordinator</h3>
                        <div className="person">
                            <div>
                                <h3 className="name">Joshua Cunningham</h3>
                                <span className="academics">Biomedical Engineering | Senior</span>
                            </div>
                        </div>
                        <p>
                            fill
                        </p>
                    </div>
                </div> */}
                {/* <div className="team-member">
                    <img src={"/team/Taffe.png"} alt={"Haley Taffe"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Facilities Coordinator</h3>
                        <div className="person">
                            <div>
                                <h3 className="name">Haley Taffe</h3>
                                <span className="academics">Biomedical Engineering | Graduate</span>
                            </div>
                        </div>
                        <p>
                            fill
                        </p>
                    </div>
                </div> */}
                {/* <div className="team-member">
                    <img src={"/team/Sajawal.jpg"} alt={"Mohammad Sajawal"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Outreach & Volunteer Coordinator</h3>
                        <div className="person">
                            <div>
                                <h3 className="name">Mohammad Sajawal</h3>
                                <span className="academics">Biomedical Engineering | Senior</span>
                            </div>
                        </div>
                        <p>
                            fill
                        </p>
                    </div>
                </div> */}
            </div>
            
            {/* <h1 className="committee">Photography & Videography</h1>
            <div className="team">
                <div className="team-member">
                    <img src={"/team/Choto.png"} alt={"Shingai Choto"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Photographer</h3>
                        <div className="person">
                            <div>
                                <h3 className="name">Shingai Choto</h3>
                                <span className="academics">Management Information Systems | Sophomore</span>
                            </div>
                        </div>
                        <p>
                            I am currently pursuing a Bachelor of Business Administration in Management
                            Information Systems at the University of Oklahoma, with plans to pursue an
                            accelerated Master's in Information Technology (expected graduation date of May 2027).
                            I'm committed to academic excellence and eager to translate my knowledge into action.
                            My diverse experiences, spanning from Zimbabwe to Swaziland to the United States,
                            have shaped my global perspective and fueled my passion to work in the IT industry.
                            On weekends, I'm usually out and about with my camera, exploring the world through
                            photography and videography.
                        </p>
                    </div>
                </div>
                <div className="team-member">
                    <img src={"/team/Nwfor.png"} alt={"Ifechukwu Chukwuka Nwafor"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Photographer</h3>
                        <div className="person">
                            <div>
                                <h3 className="name">Ifechukwu<br/>Chukwuka Nwafor</h3>
                                <span className="academics">Health & Exercise | Graduate</span>
                            </div>
                        </div>
                        <p>
                            I’m pursuing a master’s in health and exercise, with plans to graduate in May and continue
                            toward a doctorate in physical therapy. I work with the human circulatory research lab,
                            love diving into fitness, and enjoy playing sports like basketball, volleyball, and
                            badminton. You’ll often find me in the gym or capturing moments through photography! :)
                        </p>
                    </div>
                </div>
                <div className="team-member">
                    <img src={"/team/Abou-Hassoun.png"} alt={"Maon Mike Abou-Hassoun"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Photographer</h3>
                        <div className="person">
                            <div>
                                <h3 className="name">Maon Mike<br/>Abou-Hassoun</h3>
                                <span className="academics">Aerospace Engineering | Senior</span>
                            </div>
                        </div>
                        <p>
                            Maon Mike Abou-Hassoun is a 4th Year Aerospace Engineering student
                            and a Photographer at the University of Oklahoma
                        </p>
                    </div>
                </div>
                <div className="team-member">
                    <img src={"/team/Shansley.png"} alt={"Shansley Glenn"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Photographer</h3>
                        <div className="person">
                            <div>
                                <h3 className="name">Shansley Glenn</h3>
                                <span className="academics">Chemical Engineering & Communications | Junior</span>
                            </div>
                        </div>
                        <p>
                            Shansley Glen was born and raised in Honolulu, Hawaii.
                            She currently works as the lead videographer for the Gallogly College of Engineering.
                            She was a Video Production Intern for the Oklahoma CIty Thunder, and Student Producer for
                            SoonerVision and OU athletics.
                        </p>
                    </div>
                </div>
            </div> */}

            <h1 className="committee">Faculty Advisors</h1>
            <div className="team">
                <div className="team-member">
                    <img src={"/team/Suggs-Laura.jpg"} alt={"Dr. Laura Suggs"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Advisor</h3>
                        <div className="person">
                            <div>
                                <h3 className="name">Dr. Laura Suggs</h3>
                                {/* <span className="academics">SBME Teaching Focused Faculty</span> */}
                            </div>
                        </div>
                        <p> 
                            Dr. Suggs’ lab focuses on developing biologically active materials for cardiovascular tissue engineering. Their 
                            research explores how natural and synthetic polymers interact with tissues and support vasculogenesis. By guiding 
                            the differentiation of bone marrow–derived progenitor cells, they aim to engineer vascular structures for tissue 
                            regeneration. The lab combines polymer synthesis, stem cell culture, and in vitro models to study vascular development.
                        </p>
                    </div>
                </div>
                <div className="team-member">
                    <img src={"/team/edward-castillo.jpg"} alt={"Edward Castillo"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Advisor</h3>
                        <div className="person">
                            <div>
                                <h3 className="name">Dr. Edward Castillo</h3>
                                {/* <span className="academics">SBME Project Engineer</span> */}
                            </div>
                        </div>
                        <p> 
                            Dr. Castillo's research lab focuses on the theoretical development, implementation, and clinical deployment 
                            of numerical methods for medical image processing, including algorithms for the inference of patient-specific 
                            biomechanical properties from dynamic images, radiotherapy dose-response modeling, and AI based diagnostic 
                            models. These problems involve many aspects of applied mathematics, including large-scale problems in optimization, 
                            machine learning, and scientific computing.
                        </p>
                    </div>
                </div>
                {/* <div className="team-member">
                    <img src={"/team/Wolfinbarger.png"} alt={"Dr. Kim Wolfinbarger"} loading={"lazy"}/>
                    <div className="member-info">
                        <h3 className="position">Leadership Advisor</h3>
                        <div className="person">
                            <div>
                                <h3 className="name">Dr. Kim Wolfinbarger</h3>
                                <span className="academics">Jerry Holmes Leadership Program</span>
                            </div>
                        </div>
                        <p> Dr. Kim Wolfinbarger directs the Jerry Holmes Engineering Leadership Program. She teaches
                            Leadership & Management for Engineers. Her research explores leadership development among
                            students in engineering & related disciplines, with an emphasis on team leadership,
                            leadership identities, and developmental processes. She advises the Sooner Powered Vehicle
                            Team and is a member of the American Society for Engineering Education, the Human Factors &
                            Ergonomics Society, the IEEE Education Society, and IEEE’s Women in Engineering division.
                            Dr. Wolfinbarger holds a Ph.D. in Industrial & Systems Engineering, an MS in Industrial
                            Engineering, and a BBA in Marketing, all from Oklahoma.
                        </p>
                    </div>
                </div> */}
            </div>


            </body>
        </>
    );
}
export default Team;
